<micro-select-combo #sel
              placeholder="VAT Type"
              [mode]="mode"
              [(id)]="vatType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
